import has from '@dojo/framework/core/has';
export const viewFromLpl = (lpl) => {
    const { widget } = lpl;
    const params = { ...lpl };
    delete params['widget'];
    return { widget, params };
};
export const assessment = (quizid, title) => {
    return {
        widget: 'LPView',
        view: 'assessment-view',
        kids: [
            {
                widget: 'Group',
                name: 'assessment-body',
                classes: ['assessment-body'],
                kids: [
                    {
                        widget: 'Widget',
                        name: 'assessment-quiz',
                        realwidget: 'quiz',
                        jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
                    }
                ]
            }
        ]
    };
};
export const practice = (quizid, title) => {
    return {
        widget: 'LPView',
        view: 'practice-view',
        kids: [
            {
                widget: 'Group',
                name: 'practice-body',
                classes: ['practice-body'],
                kids: [
                    {
                        widget: 'Widget',
                        name: 'practice-quiz',
                        realwidget: 'quiz',
                        jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
                    }
                ]
            }
        ]
    };
};
export const bonus = (quizid, title) => {
    return {
        widget: 'LPView',
        view: 'bonusquiz-view',
        kids: [
            {
                widget: 'Group',
                name: 'bonusquiz-body',
                classes: ['bonusquiz-body'],
                kids: [
                    {
                        widget: 'Widget',
                        name: 'bonus-quiz',
                        realwidget: 'quiz',
                        jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
                    }
                ]
            }
        ]
    };
};
export const posttest = (quizid, title) => {
    const kids = [
        {
            widget: 'Widget',
            name: 'posttest-quiz',
            realwidget: 'quiz',
            jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
        }
    ];
    if (has('use-micro-view')) {
        kids.unshift({
            widget: 'Widget',
            name: 'posttest-breadcrumbs',
            realwidget: 'MicroBreadcrumbs',
            jsondata: '{}'
        });
    }
    return {
        widget: 'LPView',
        view: 'posttest-view',
        kids: [
            {
                widget: 'Group',
                name: 'posttest-body',
                classes: ['posttest-body'],
                kids
            }
        ]
    };
};
export const quiz = (quizid, title) => {
    return {
        widget: 'LPView',
        view: 'quiz-view',
        kids: [
            {
                widget: 'Group',
                name: 'quiz-body',
                classes: ['quiz-body'],
                kids: [
                    {
                        widget: 'Widget',
                        name: 'quiz-breadcrumbs',
                        realwidget: 'MicroBreadcrumbs'
                    },
                    {
                        widget: 'Widget',
                        name: 'general-quiz',
                        realwidget: 'quiz',
                        jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
                    }
                ]
            }
        ]
    };
};
